import { render } from "./Icon.vue?vue&type=template&id=0ef2d619"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import "./Icon.vue?vue&type=style&index=0&id=0ef2d619&lang=scss"
script.render = render

export default script